import { put } from 'utils/dict'
import { freeze } from 'utils/dom'
import { intcmp } from 'utils/string'

import { normalizeChallengeLinks } from './challenge'
import { normalizeChallengeInputGroups } from './inputGroup'

export const defaultJourney = freeze({
  id: '',
  name: '',
  groupsL: [],
  groupsD: {},
  groupsShort: {},
  groupsShow: [],
  input2group: {},
  milestonesD: {},
  milestonesL: [],
  milestonesShort: {}
  // milestonesOpen: {}
})

export function normalizeJourney(
  {
    milestones,
    inputGroups: groups,
    id,
    name,
    meta = {},
    status,
    description,
    type,
    org,
    ...orig
  },
  actor
) {
  const { milestonesD, milestonesL } = normalizeMilestones(milestones, orig)
  const { groupsL, groupsD, groupsShort, groupsShow } =
    normalizeChallengeInputGroups(groups, actor)
  return freeze({
    id,
    name,
    meta,
    status,
    description,
    type,
    org: { ...org },
    groupsL,
    groupsD,
    groupsShort,
    groupsShow,
    milestonesD,
    milestonesL
  })
}

function reduceMilestones(acc, ms) {
  return put(acc, ms.id, normalizeMilestone(ms))
}

export function normalizeMilestone({ id, name, order, meta, challengeLinks }) {
  const { cLinksD, cLinksL } = normalizeChallengeLinks(challengeLinks)
  return freeze({ id, name, order, meta, cLinksD, cLinksL })
}

export function normalizeMilestones(
  // new stuffs
  milestones,
  // for previous history... (TBD why)
  { milestonesD = {}, milestonesL = [] }
) {
  if (milestones !== undefined) {
    milestonesD = milestones.reduce(reduceMilestones, {})
    milestonesL = milestones
      .toSorted((a, b) => intcmp(a.order, b.order))
      .map((m) => m.id)
  }
  return { milestonesD, milestonesL }
}
